import http from '@/utils/ajax'
import { SMSBALANCE_INIT_LOADING, SMSBALANCE_INIT_SUCCESS, SMSBALANCE_INIT_FAIL } from '@/store/types'
const state = {
  smsBalance: {
    init: 0,
    balance: ''
  }
}

const getters = {

}

const actions = {
  async initSMSBalance({ commit, state }) {
    commit(SMSBALANCE_INIT_LOADING)
    const apiUrl = state.permitWidgets.smsBalance
    if (apiUrl) {
      try {
        const result = await http.get(apiUrl)
        const data = {
          smsBalance: result.data.data.balance
        }
        commit(SMSBALANCE_INIT_SUCCESS, data)
      } catch (error) {
        commit(SMSBALANCE_INIT_FAIL)
      }
    } else {
      commit(SMSBALANCE_INIT_FAIL)
    }
  }
}

const mutations = {
  [SMSBALANCE_INIT_LOADING](state) {
    state.smsBalance.init = 0
  },
  [SMSBALANCE_INIT_SUCCESS](state, data) {
    const { smsBalance } = state
    smsBalance.balance = data.smsBalance
    smsBalance.init = 1
  },
  [SMSBALANCE_INIT_FAIL](state) {
    state.smsBalance.init = 2
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
